import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DenounceAdminService } from '../../../../services/denounce-admin.service';

export interface AdminUploadedFile {
  storageKey: string;
  fileName: string;
  fileSize: number;
  fileType: string;
}

const ALLOWED_EXTENSIONS = [
  'png', 'jpg', 'jpeg', 'gif', 'wav', 'mp3',
  'mp4', 'mov', 'avi', 'wmv', 'doc', 'docx', 'ppt', 'xls', 'xlsx', 'pdf',
];

@Component({
  selector: 'app-admin-file-uploader',
  templateUrl: './admin-file-uploader.component.html',
  styleUrls: ['./admin-file-uploader.component.sass'],
})
export class AdminFileUploaderComponent {
  @Input() maxFiles = 4;
  @Output() filesChanged = new EventEmitter<AdminUploadedFile[]>();

  files: AdminUploadedFile[] = [];
  uploading = false;
  dragging = false;

  constructor(
    private snackBar: MatSnackBar,
    private adminService: DenounceAdminService,
  ) {}

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.dragging = true;
  }

  onDragLeave(): void {
    this.dragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragging = false;
    if (event.dataTransfer?.files) {
      this.handleFiles(event.dataTransfer.files);
    }
  }

  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.handleFiles(input.files);
      input.value = '';
    }
  }

  private handleFiles(fileList: FileList): void {
    const remaining = this.maxFiles - this.files.length;
    if (remaining <= 0) {
      this.snackBar.open(`Máximo ${this.maxFiles} archivos`, 'Cerrar', { duration: 3000 });
      return;
    }

    for (const file of Array.from(fileList).slice(0, remaining)) {
      const ext = file.name.split('.').pop()?.toLowerCase() || '';
      if (!ALLOWED_EXTENSIONS.includes(ext)) {
        this.snackBar.open(`Formato .${ext} no permitido`, 'Cerrar', { duration: 3000 });
        continue;
      }
      this.uploadSingle(file);
    }
  }

  private uploadSingle(file: File): void {
    this.uploading = true;
    const reader = new FileReader();
    reader.onload = () => {
      this.adminService.uploadFile(reader.result as string, file.name).subscribe({
        next: (res) => {
          this.files.push(res);
          this.filesChanged.emit(this.files);
          this.uploading = false;
        },
        error: (err) => {
          this.snackBar.open(err.message || 'Error al subir archivo', 'Cerrar', { duration: 3000 });
          this.uploading = false;
        },
      });
    };
    reader.readAsDataURL(file);
  }

  removeFile(index: number): void {
    this.files.splice(index, 1);
    this.filesChanged.emit(this.files);
  }
}
